export class Location {
    locationId: string;
    locationIdCode: string;
    locationName: string;

    private constructor(locationId: string | undefined, locationIdCode: string | undefined, locationName: string | undefined) {
        if (locationId === undefined) {
            throw new Error('locationId undefined');
        }
        if (locationIdCode === undefined) {
            throw new Error('locationIdCode undefined');
        }
        if (locationName === undefined) {
            throw new Error('locationName undefined');
        }

        this.locationId = locationId;
        this.locationIdCode = locationIdCode;
        this.locationName = locationName;
    }

    static create({
        locationId,
        locationIdCode,
        locationName,
    }: {
        locationId: string | undefined;
        locationIdCode: string | undefined;
        locationName: string | undefined;
    }): Location {
        return new Location(locationId, locationIdCode, locationName);
    }
}
